import React, { useState } from "react";
import axios from "axios"; // Make sure to install axios: npm install axios

const UploadJTWC = () => {
  const [cycloneName, setCycloneName] = useState("");
  const [date, setDate] = useState("");
  const [kmlFile, setKmlFile] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.name.endsWith(".kml")) {
        setError("Please upload a valid KML file.");
        setKmlFile(null);
      } else {
        setError("");
        setKmlFile(file);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (!cycloneName) {
      setError("Please select the name of the cyclone.");
      return;
    }
    if (!date) {
      setError("Please select the date.");
      return;
    }
    if (!kmlFile) {
      setError("Please upload the KML track.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("cyclone_name", cycloneName);
    formData.append("track_date", date); // Match the backend field name
    formData.append("kml_file", kmlFile); // Match the backend field name

    try {
      const response = await axios.post(
        `${backendUrl}/cyclone/jtwc-cyclone-track/`, // Replace with your actual API endpoint
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Upload successful:", response.data);
      setSuccess("KML file uploaded successfully!");
      setLoading(false);
      // Reset form
      setCycloneName("");
      setDate("");
      setKmlFile(null);
      document.querySelector("input[type=file]").value = null; // Clear file input
    } catch (err) {
      console.error("Upload error:", err.response ? err.response.data : err);
      setError("Failed to upload the file. Please try again.");
      setLoading(false);
    }
  };

  const styles = {
    // ... (Your existing styles) ...
    container: {
        padding: "30px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        maxWidth: "500px",
        margin: "40px auto",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
      },
      title: {
        textAlign: "center",
        marginBottom: "25px",
        color: "#333",
      },
      formGroup: {
        marginBottom: "20px",
      },
      label: {
        display: "block",
        fontWeight: "600",
        marginBottom: "8px",
        color: "#444",
      },
      select: {
        width: "100%",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        fontSize: "14px",
        backgroundColor: "#f9f9f9",
        transition: "border-color 0.3s",
      },
      inputFile: {
        display: "block",
        marginTop: "8px",
      },
      button: {
        padding: "12px 24px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "600",
        width: "100%",
        transition: "background-color 0.3s",
      },
      buttonHover: {
        backgroundColor: "#0056b3",
      },
      error: {
        color: "red",
        marginTop: "10px",
        textAlign: "center",
      },
      success: {
          color: "green",
          marginTop: "10px",
          textAlign: "center",
      },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Upload JTWC Cyclone Track</h2>
      <form onSubmit={handleSubmit}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Name of the Cyclone</label>
          <select
            value={cycloneName}
            onChange={(e) => setCycloneName(e.target.value)}
            style={styles.select}
          >
            <option value="">Select Cyclone</option>
            <option value="Cyclone1">Cyclone 1</option>
            <option value="Cyclone2">Cyclone 2</option>
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Date</label>
          <select
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={styles.select}
          >
            <option value="">Select Date</option>
            <option value="2020-01-01">2020-01-01</option>
            <option value="2021-01-20">2021-01-20</option>
            <option value="2022-01-30">2022-01-30</option>
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Upload the KML Track</label>
          <input
            type="file"
            accept=".kml"
            onChange={handleFileChange}
            style={styles.inputFile}
          />
        </div>

        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? "Uploading..." : "Submit"}
        </button>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}
      </form>
    </div>
  );
};

export default UploadJTWC;